import { join } from 'js-utils/path';
import { push } from 'react-router-redux';
import { trackEventFromState } from '@eb/site-analytics';

import { getEventsWithDowngradeConflicts, getEventsData } from '../api';
import { setPackageOne, _trackEventActionsAU } from './changePlan';
import {
    GA_PACKAGE_DOWNGRADED,
    GA_CHANGE_PLAN_CATEGORY,
    GA_DOWNGRADE_PAGE_CLICK,
    GA_P2_LABEL,
} from '../constants/analytics';
import {
    PACKAGE_ONE_QUERY_STRING,
    DEFAULT_PAGE_NUMBER,
} from '../constants/downgrade';
import {
    BASE_URL,
    CHANGE_PLAN_DOWNGRADE_PATH,
    CHANGE_PLAN_DOWNGRADE_CONFLICTS_PATH,
} from '../constants/main';

export const hasDowngradeConflicts = (conflictsApiResponse) => {
    const { objectCount } = conflictsApiResponse.pagination;
    return !!objectCount;
};

export const assembleConflictsData = ({ conflicts, events }) => {
    const { downgradeConflicts } = conflicts;
    const conflictsWithExpandedEvents = downgradeConflicts.reduce(
        (acc, { eventId, downgradeConflicts }) => [
            ...acc,
            {
                downgradeConflicts,
                event: events.find((e) => e.id === eventId),
            },
        ],
        [],
    );
    return { ...conflicts, downgradeConflicts: conflictsWithExpandedEvents };
};

export const STORE_CONFLICTS = 'STORE_CONFLICTS';
export const IS_FETCHING = 'IS_FETCHING';

export const storeConflicts = (payload) => ({
    type: STORE_CONFLICTS,
    payload,
});

export const isFetching = (payload = true) => ({
    type: IS_FETCHING,
    payload,
});

export const checkConflicts = () => async (dispatch, getState) => {
    const state = getState();
    const {
        user: { activeScopeUserId },
    } = state;
    const eventsWithDowngradeConflicts = await getEventsWithDowngradeConflicts({
        organizationId: activeScopeUserId,
        desiredPackage: PACKAGE_ONE_QUERY_STRING,
    });
    trackEventFromState(state, {
        action: GA_DOWNGRADE_PAGE_CLICK,
        label: GA_P2_LABEL,
        category: GA_CHANGE_PLAN_CATEGORY,
    });

    if (hasDowngradeConflicts(eventsWithDowngradeConflicts)) {
        const eventIds = eventsWithDowngradeConflicts.downgradeConflicts.map(
            (item) => item.eventId,
        );
        const { events } = await getEventsData(eventIds);
        dispatch(
            storeConflicts(
                assembleConflictsData({
                    events,
                    conflicts: eventsWithDowngradeConflicts,
                }),
            ),
        );
        dispatch(
            push(
                join(
                    BASE_URL,
                    CHANGE_PLAN_DOWNGRADE_PATH,
                    CHANGE_PLAN_DOWNGRADE_CONFLICTS_PATH,
                ),
            ),
        );
    } else {
        dispatch(_trackEventActionsAU(GA_PACKAGE_DOWNGRADED));
        dispatch(setPackageOne());
    }
};

export const getConflictsPayload = async (
    organizationId,
    desiredPackage,
    pageNumber,
) => {
    const response = await getEventsWithDowngradeConflicts({
        organizationId,
        desiredPackage,
        pageNumber,
    });
    const eventIds = response.downgradeConflicts.map((item) => item.eventId);
    const { events } = await getEventsData(eventIds);

    return assembleConflictsData({ events, conflicts: response });
};

export const fetchConflicts = (pageNumber = DEFAULT_PAGE_NUMBER) => async (
    dispatch,
    getState,
) => {
    const {
        user: { activeScopeUserId },
    } = getState();

    dispatch(isFetching(true));
    const payload = await getConflictsPayload(
        activeScopeUserId,
        PACKAGE_ONE_QUERY_STRING,
        pageNumber,
    );

    dispatch(isFetching(false));
    dispatch(storeConflicts(payload));
    return {
        ...payload,
        downgradeConflicts: {
            0: payload.downgradeConflicts,
        },
    };
};
